<template>
  <div class="border-t border-gray-200 pt-3 sm:pt-4 dark:border-gray-700">
    <div class="mb-3 flex items-center justify-between">
      <h4 class="text-sm font-medium text-gray-900 dark:text-white">
        Opciones
      </h4>
    </div>

    <div class="space-y-2">
      <!-- Headers -->
      <div class="grid grid-cols-12 gap-2 px-3 py-2 text-xs font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
        <div class="col-span-7">
          Nombre
        </div>
        <div class="col-span-2">
          Precio delta
        </div>
        <div class="col-span-2 text-center">
          Activa
        </div>
        <div class="col-span-1 text-center" />
      </div>
      
      <div
        v-for="(option, index) in optionsModel"
        :key="`option-${index}`"
      >
        <div class="grid grid-cols-1 gap-2 sm:grid-cols-12 sm:items-center">
          <input
            v-model="option.name"
            type="text"
            placeholder="Nombre de la opción"
            class="sm:col-span-7 w-full rounded-md border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
          >

          <input
            v-model.number="option.price_delta"
            type="number"
            min="0"
            step="0.01"
            placeholder="Precio delta"
            class="sm:col-span-2 w-full rounded-md border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
          >

          <label class="sm:col-span-2 inline-flex items-center justify-center gap-2 rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-600 dark:border-gray-700 dark:text-gray-300">
            <input
              v-model="option.is_active"
              type="checkbox"
              class="h-4 w-4 rounded border-gray-300 text-indigo-600"
            >
          </label>

          <button
            type="button"
            class="sm:col-span-1 w-10 rounded-md bg-red-50 py-2 text-sm font-medium text-red-600 transition-colors hover:bg-red-100 dark:bg-red-900/20 dark:text-red-400 sm:bg-transparent sm:py-1 sm:text-xs sm:hover:bg-transparent sm:hover:text-red-700"
            @click="removeOption(index)"
          >
            <span class="sm:hidden">Eliminar opción</span>
            <span class="hidden sm:inline">✕</span>
          </button>
        </div>
      </div>
      <button
        type="button"
        class="rounded-md bg-gray-100 px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-200"
        @click="addOption"
      >
        Agregar opción
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ModifierOption } from '@/types/menu';

const optionsModel = defineModel<ModifierOption[]>('options', { required: true });

const createDefaultOption = (): ModifierOption => ({
  name: '',
  price_delta: 0,
  is_active: true,
  sort_order: 0
});

function addOption() {
  optionsModel.value.push(createDefaultOption());
}

function removeOption(index: number) {
  optionsModel.value.splice(index, 1);

  if (optionsModel.value.length === 0) {
    optionsModel.value.push(createDefaultOption());
  }
}
</script>
